import { Schema } from "effect";
export const Meta = Schema.Struct({
    object: Schema.Literal("client.meta"),
    data: Schema.Struct({
        requiresUpgrade: Schema.Boolean
    })
});
